import { useLocalStorage } from 'usehooks-ts';
import { Switch } from '../ui/Switch/Switch';

export const POCToggle = () => {
    const [isEnabled, setIsEnabled] = useLocalStorage('is-poc-enabled', false);

    return (
        <div>
            <Switch checked={isEnabled} onCheckedChange={setIsEnabled} />
        </div>
    );
};
